<template>
  <div
    class="error-page d-flex flex-column align-center justify-center h-screen bg-light"
  >
    <h1 class="fw-bolder fs-2hx text-gray-900 mb-4">
      {{ COMMON_CONSTANTS.TEXT.OPS }}
    </h1>

    <div class="fw-semibold fs-6 text-gray-500 mb-7">
      {{ errorMessage || COMMON_CONSTANTS.DEFAULT_ERROR_MESSAGE_404 }}
    </div>
    <v-btn data-testid="error-page-button" variant="outlined" @click="goBack">
      {{
        loginTypeError
          ? COMMON_CONSTANTS.TEXT.CHECK_OUT_OUR_WEBSITE
          : COMMON_CONSTANTS.TEXT.GO_BACK
      }}
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { COMMON_CONSTANTS } from "@/constants/common-constants";
const errorStore = useErrorStore();
const errorMessage = computed(() => errorStore.getErrorMessage);
const loginTypeError = computed(() => errorStore.getLoginTypeError);

const goBack = () => {
  if (loginTypeError.value) {
    window.location.href = import.meta.env.VITE_DEFAULT_REDIRECT_URL;
  } else {
    useRouter().back();
  }
};
</script>

<style scoped>
/* Add any additional styles here */
</style>
